// In-memory access-token store (issue #6).
//
// Tokens were previously kept in localStorage, where any XSS payload could
// read them and they survived across browser sessions. The access token now
// lives only in module memory for the lifetime of the tab; the refresh token
// is an httpOnly cookie set by the backend, so JavaScript never sees it. On
// page reload the app silently re-authenticates via POST /auth/refresh
// (cookie) and receives a fresh, short-lived access token.
let accessToken: string | null = null;

export const tokenStore = {
  get: (): string | null => accessToken,
  set: (token: string | null): void => {
    accessToken = token;
  },
  clear: (): void => {
    accessToken = null;
  },
};

// One-time cleanup of tokens persisted by older versions of the app.
export const purgeLegacyTokenStorage = (): void => {
  if (typeof window === "undefined") return;
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("token");
};
